import {
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  DOWNLOAD_FILE_REQUEST,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILURE,
} from "./actionTypes";

export const uploadImage = (file: Blob | File, fileName: string) => ({
  type: UPLOAD_IMAGE_REQUEST,
  payload: { file, fileName },
});

export const uploadImageSuccess = (imageUri: string | undefined) => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: { imageUri },
});

export const uploadImageFailure = (error: string) => ({
  type: UPLOAD_IMAGE_FAILURE,
  payload: { error },
});

export const downloadFileRequest = (fileUrl: string, customFileName?: string) => ({
  type: DOWNLOAD_FILE_REQUEST,
  payload: { fileUrl, customFileName },
});

export const downloadFileSuccess = () => ({
  type: DOWNLOAD_FILE_SUCCESS,
});

export const downloadFileFailure = (error: string) => ({
  type: DOWNLOAD_FILE_FAILURE,
  payload: { error },
});
